// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_LIST_OF_GROUPS = "Sp\u00e4\u0165 na zoznam skup\u00edn";
